import { t } from '@/i18n';
import { z } from 'zod';

const errorMessages = {
  required: t('pages.login.schemas.login_form.required'),
  invalidEmail: t('pages.login.schemas.login_form.invalid_email'),
};

export const loginFormSchema = z.object({
  email: z.string().min(1, errorMessages.required).email(errorMessages.invalidEmail),
  password: z.string().min(1, errorMessages.required),
  rememberMe: z.boolean().default(false),
});
